import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {

  _authService = inject(AuthService);
  _router = inject(Router);
  _toast = inject(ToastService);


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this._authService.getAuthToken();
    const isPublicGuarantorRequest = request.url.includes('/loan-guarantors') &&
      !request.url.includes('/loan-guarantors/send-sms');
    const isPublicFormRequest = request.url.includes('/forms/by-token') ||
      request.url.includes('/forms/submit');
    const isPublicRequest = isPublicGuarantorRequest || isPublicFormRequest;

    if (token && !isPublicRequest) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === 401 && !isPublicRequest) {
          this._router.navigate(['/auth/login']);
        }

        if (error.status === 429) {
          this._toast.error('Too many requests, please try again later.');
        }

        const errorMsg = error.error?.message || error.error?.response_message || 'An unknown error occurred';
        const customError: any = new Error(errorMsg);
        customError.status = error.status;
        customError.error = error.error;
        return throwError(() => customError);
      })
    );
  }
}
